import { render, staticRenderFns } from "./ConflictedProjects.vue?vue&type=template&id=f9874e40&scoped=true&"
import script from "./ConflictedProjects.vue?vue&type=script&lang=js&"
export * from "./ConflictedProjects.vue?vue&type=script&lang=js&"
import style0 from "./ConflictedProjects.vue?vue&type=style&index=0&id=f9874e40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9874e40",
  null
  
)

export default component.exports